import Component from '@bythepixel/component-loader';

export default class DigitalCallTreeButton extends Component {
  static selector = '[data-comp-digital-call-tree-button]';

  dialog = null;

  constructor(containerEl, options) {
    super(containerEl, options);

    this.registerTriggerEvents();
  }

  openDialog() {
    this.dialog.showModal();
  }

  registerTriggerEvents() {
    const button = this.$container.querySelector('button');
    const { dialogId } = this.$container.dataset;
    this.dialog = document.getElementById(dialogId);

    button?.addEventListener('click', this.openDialog.bind(this));
  }
}
